// extracted by mini-css-extract-plugin
export default {"modal":"IndicatorModal_modal__jiQpO","modalBody":"IndicatorModal_modalBody__x4Tlb","modalButtons":"IndicatorModal_modalButtons__CjI5F","button":"IndicatorModal_button__01T8f"};